var _excluded = ["variant", "children"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from 'react';
import { Radio as RadioMui, FormControlLabel } from '@mui/material';
import { colors } from '../../@theme/colors';
var theme = {
  corporate: {
    active: colors.WomCorp,
    inactive: colors.Neutros40
  },
  black: {
    active: colors.WomCorp80,
    inactive: colors.Neutros60
  },
  disabled: colors.Neutros20
};
var Radio = function Radio(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'corporate' : _ref$variant,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var radioSX = {
    color: theme[variant].inactive,
    '&.Mui-checked': {
      color: theme[variant].active
    },
    '&.Mui-disabled': {
      color: theme['disabled']
    }
  };
  return React.createElement(FormControlLabel, _extends({}, props, {
    control: React.createElement(RadioMui, {
      sx: radioSX
    }),
    label: children
  }));
};
export default Radio;